import {
  createApiResource,
  ResourceId,
  CreateResource,
  PatchResource,
  UnpagedListResource,
  GetByIdResource
} from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import {
  ServiceTitanLocationQueryParams,
  Location,
  LocationCreateDTO,
  LocationDetailDTO,
  LocationPatchDTO
} from '../apiTypes.shim';
import { ApiResourceWithContacts, createContactsResource } from '../stApiResourceFactory';

import type { SetRequired } from 'type-fest';

type AllCustomerLocationsParams = SetRequired<ServiceTitanLocationQueryParams, 'providerCustomerId'>;

export interface ServiceTitanLocationResource
  extends CreateResource<LocationCreateDTO, LocationDetailDTO>,
    GetByIdResource<Location>,
    PatchResource<LocationPatchDTO, Location>,
    ApiResourceWithContacts {
  useAllCustomerLocations: UnpagedListResource<
    Location,
    AllCustomerLocationsParams,
    { requireParams: true }
  >['useUnpagedList'];
  allCustomerLocations: UnpagedListResource<
    Location,
    AllCustomerLocationsParams,
    { requireParams: true }
  >['unpagedList'];
}

export const createServiceTitanLocationResource = (companyId: string): ServiceTitanLocationResource => {
  const uri = `${companyId}/locations`;

  const { useUnpagedList, unpagedList, getById, useGetById, create, useCreate, patch, usePatch, getByIdQueryKey } =
    createApiResource(ServiceTitanAPI, uri);

  const contacts = (locationId: ResourceId) => createContactsResource(ServiceTitanAPI, `${uri}/${locationId}`);

  return {
    useAllCustomerLocations: useUnpagedList,
    allCustomerLocations: unpagedList,
    getById,
    useGetById,
    create,
    useCreate,
    patch,
    usePatch,
    contacts,
    getByIdQueryKey
  };
};
